import React from "react";
import EventPublisher from "../../utils/EventPublisher";
import StoreUpdateEvents from "../../constants/events/StoreUpdateEvents";
import LoadingStates from "../../constants/states/LoadingStates";
import GoogleAPILibStore from "../../stores/GoogleAPILibStore";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import SavingStates from "../../constants/states/SavingStates";
import SpaceEditViewStore from "../../stores/SpaceEditViewStore";
import SpaceEditView from "../views/SpaceEditView";
import ImageUploaderStore from "../../stores/ImageUploaderStore";
import LoadingView from "../views/LoadingView";


class SpaceEditContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            "googleAPILibState": GoogleAPILibStore.getState(),
            "spaceEditViewStoreState": SpaceEditViewStore.getState(),
            "imageUploaderStore": ImageUploaderStore.getState()
        };
    }

    componentDidMount() {
        this.googleAPILibStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.GOOGLE_API_LIB_STORE_UPDATED, this.handleStoreUpdate);
        this.spaceEditViewStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.SPACE_EDIT_VIEW_STORE_UPDATED, this.handleStoreUpdate);
        this.imageUploaderStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.IMAGE_UPLOADER_STORE_UPDATED, this.handleStoreUpdate);
        EventPublisher.publish(UIInteractionEvents.GOOGLE_API_LIB_REQUIRED, {});
        EventPublisher.publish(UIInteractionEvents.SPACE_EDIT_SET_SPACE_ID, {"id" :this.props.match.params.id})
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevState.spaceEditViewStoreState.imageNames.currentValue !== this.state.spaceEditViewStoreState.imageNames.currentValue) {
            EventPublisher.publish(UIInteractionEvents.LOAD_IMAGES_FOR_EDIT, {imageNames: this.state.spaceEditViewStoreState.imageNames.currentValue});
        }
    }

    componentWillUnmount() {
        EventPublisher.unsubscribe(this.googleAPILibStoreSubscriber);
        EventPublisher.unsubscribe(this.spaceEditViewStoreSubscriber);
        EventPublisher.unsubscribe(this.imageUploaderStoreSubscriber);
        EventPublisher.publish(UIInteractionEvents.REST_IMAGE_STORE, {});
    }

    handleStoreUpdate = (topic, data) => {
        this.setState({
            "googleAPILibState": GoogleAPILibStore.getState(),
            "spaceEditViewStoreState": SpaceEditViewStore.getState(),
            "imageUploaderStore": ImageUploaderStore.getState()
        });
    };

    render() {
        if (this.state.spaceEditViewStoreState.loadingState !== LoadingStates.FINISHED_LOADING) {
            return (
                <LoadingView titleText="Loading Space"/>
            );
        }

        return (
            <SpaceEditView
                isSaving={this.state.spaceEditViewStoreState.savingState === SavingStates.SAVING}
                googleAPILibReady={this.state.googleAPILibState.loadingState === LoadingStates.FINISHED_LOADING}
                title={this.state.spaceEditViewStoreState.title}
                isLimitedEdit={this.state.spaceEditViewStoreState.isLimitedEdit}
                description={this.state.spaceEditViewStoreState.description}
                price={this.state.spaceEditViewStoreState.price}
                minimumDays={this.state.spaceEditViewStoreState.minimumDays}
                spaceAddressGooglePlaceId={this.state.spaceEditViewStoreState.spaceAddressGooglePlaceId}
                spaceAddressLatitude={this.state.spaceEditViewStoreState.spaceAddressLatitude}
                spaceAddressLongitude={this.state.spaceEditViewStoreState.spaceAddressLongitude}
                spaceAddress={this.state.spaceEditViewStoreState.spaceAddress}
                spaceId={this.state.spaceEditViewStoreState.spaceId}
                showingImageSlideIndex={this.state.imageUploaderStore.currentShownImageIndex}
                imageNames={this.state.imageUploaderStore.imageNames}
                uploadPercentage={this.state.imageUploaderStore.currentUploadPercentage()}
                isDirtyImages={this.state.spaceEditViewStoreState.imageNames.isTouched}
            />
        );
    }

}

export default SpaceEditContainer;